import "./App.css";
import { AuthProvider } from "./common/components/auth/AuthProvider";
import AuthWrapper from "./common/components/auth/LoadingAuthData";
import { ToastProvider } from "./common/components/ui/toast/toast.provider";
import Routes from "./routes";

import Toast from "./common/components/ui/toast";
import { VersionUpdateToast } from "./common/components/ui/VersionUpdateToast";

function App() {
  return (
    <ToastProvider>
      <Toast />
      <AuthWrapper>
        <AuthProvider>
          <Toast />
          <VersionUpdateToast />
          <Routes />
        </AuthProvider>
      </AuthWrapper>
    </ToastProvider>
  );
}

export default App;
